module.exports = __webpack_public_path__ + "img/Slide7.87bfe093.jpg";